<!-- Main container with Material sidenav overlay -->
<mat-sidenav-container class="h-screen ambient" [appScreenWakeLock]="screenWakeLockActive" (wakeLockUnavailable)="onWakeLockUnavailable($event)" [ngClass]="{
  'ambient-blue': theme === 'blue',
  'ambient-recording': theme === 'recording',
  'ambient-light': theme === 'light',
}">

  <ng-template #encounterContentPanel>
    <app-encounter-content-panel
      [class.h-full]="!isMobile"
      [class.w-full]="!isMobile"
      [notes]="notes"
      [copilot]="dictation!.copilot!"
      [utterances]="transcriptUtterances"
      [transcriptEnabled]="transcriptTabEnabled"
      [uiState]="encounterUiState"
      [isMobile]="isMobile"
      [isLegalOrg]="isLegalOrg"
      [showClose]="false"
      [(selectedTabIndex)]="contentPanelTabIndex"
      (saveNote)="onPanelSaveNote($event)"
      (deleteNote)="deleteNote($event)"
      data-testid="encounter-content-panel" />
  </ng-template>

  <!-- Right overlay drawer -->
  <mat-sidenav #rightDrawer mode="over" position="end" (closed)="onDrawerClosed()"
  class="w-[360px] max-w-[90vw] h-screen overflow-hidden" data-testid="encounter-notes-drawer">
    @if (!showEncounterContentPanel) {
    <ng-container [ngSwitch]="activeDrawer">
      <!-- Notes drawer -->
      <div *ngSwitchCase="'context'" class="h-screen flex flex-col overflow-hidden">
        <!-- Header with tabs -->
        <div class="flex h-14 items-center gap-2 pl-4 bg-[rgba(255,255,255,0.08)]">
          <div class="flex h-full items-center justify-start w-full tab-container">
            <!-- Tab 1: Transcript -->
            <!-- <div class="flex flex-col h-full items-center justify-end flex-1 tab" 
                 [class.active]="activeNotesTab === 'transcript'"
                 (click)="setActiveNotesTab('transcript')">
              <div class="flex flex-col grow items-center justify-center px-4 py-3.5 flex-1 w-full">
                <div class="flex gap-1 grow items-center justify-center flex-1">
                  <div class="flex flex-col font-medium justify-center leading-0 relative shrink-0 text-base text-center text-nowrap text-white tracking-[0.15px]">
                    <p class="leading-6 whitespace-pre">{{ 'Transcript' | translate }}</p>
                  </div>
                </div>
              </div> -->
              <!-- Tab indicator -->
              <!-- <div class="absolute bg-white bottom-0 h-0.5 left-0 right-0 tab-indicator" 
                   [class.opacity-100]="activeNotesTab === 'transcript'"></div> -->
            <!-- </div> -->
            <!-- Tab 2: Context -->
            <div class="flex flex-col h-full items-center justify-end flex-1 relative tab transition-all duration-200 cursor-pointer hover:bg-white/5"
                 (click)="setActiveNotesTab('context')">
              <div class="flex flex-col grow items-center justify-center px-4 py-3.5 flex-1 w-full">
                <div class="flex gap-1 grow items-center justify-center flex-1">
                  <div class="flex flex-col font-medium justify-center leading-0 relative shrink-0 text-base text-center text-nowrap text-white tracking-[0.15px]">
                    <p class="leading-6 whitespace-pre">{{ 'Notes' | translate }}</p>
                  </div>
                </div>
              </div>
              <!-- Tab indicator -->
              <div class="absolute bg-white bottom-0 h-0.5 left-0 right-0 tab-indicator opacity-0 transition-opacity duration-200"
                   [class.opacity-100]="activeNotesTab === 'context'"></div>
            </div>
          </div>
          <!-- Close button -->
          <div class="mr-1">
            <button mat-icon-button class="p-1.5" (click)="closeDrawer()" data-testid="encounter-close-drawer-button">
              <mat-icon class="!text-inverse-on-surface opacity-50 !text-lg">close</mat-icon>
            </button>
          </div>
        </div>
        
        <!-- Content Container -->
        <div class="flex flex-col grow items-start justify-start flex-1 w-full overflow-hidden">
          <!-- Transcript/Context Content -->
          <!-- <div class="grow h-full items-end justify-between overflow-x-clip overflow-y-auto flex-1"> -->
            
            <!-- Transcript Tab Content -->
            <div *ngIf="activeNotesTab === 'transcript'" class="flex flex-col grow items-start justify-between flex-1 w-full overflow-hidden">
              <!-- Text input area -->
              <div class="flex flex-col items-start justify-center flex-1 w-full">
                <div class="flex items-center justify-start px-0 py-2 relative rounded-lg flex-1 w-full">
                  <!-- Blinking cursor -->
                  <div class="h-6 relative shrink-0 w-3 animate-pulse">
                    <div class="absolute left-0 size-6 top-0"></div>
                    <div class="absolute flex h-4.5 items-center justify-center left-1.5 top-1 w-0">
                      <div class="flex-none rotate-90">
                        <div class="h-0 relative w-4.5">
                          <img src="/assets/icon-cursor.svg" alt="cursor" class="block max-w-none size-full" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="font-normal leading-0 opacity-50 relative shrink-0 text-sm text-nowrap text-white tracking-[0.25px]">
                    <p class="leading-5 whitespace-pre">{{ 'Add context note…' | translate }}</p>
                  </div>
                </div>
              </div>
              
              <!-- Attachments section -->
              <div class="flex flex-col items-end justify-center flex-1 w-full">
                <div class="flex gap-1 items-center justify-end relative rounded-lg flex-1 w-full">
                  <div class="font-normal leading-0 opacity-50 relative shrink-0 text-xs text-nowrap text-white tracking-[0.4px]">
                    <p class="leading-4 whitespace-pre">{{ 'No attachements' | translate }}</p>
                  </div>
                  <div class="flex flex-col gap-1.5 items-center justify-center p-1 relative shrink-0 size-6 cursor-pointer transition-all duration-200 hover:bg-white/10">
                    <div class="relative rounded-full shrink-0">
                      <div class="flex gap-1.5 items-center justify-center overflow-clip relative">
                        <div class="flex gap-1.5 items-center justify-center p-1 relative shrink-0">
                          <div class="overflow-clip relative shrink-0 size-3">
                            <img src="/assets/icon-attachment.svg" alt="attachment" class="block max-w-none size-full" />
                          </div>
                        </div>
                      </div>
                      <div aria-hidden="true" class="absolute border border-outline-variant border-solid inset-0 pointer-events-none rounded-full"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Context Tab Content -->
            <div *ngIf="activeNotesTab === 'context'" class="flex flex-col grow flex-1 w-full justify-between overflow-hidden">
              <!-- Context notes section -->
              <div class="flex flex-col pl-4 pt-6 pb-4 gap-2.5 grow min-h-0 relative" #contextNotesContainer>
                <div class="overflow-y-auto" #notesListContainer>
                  <div *ngFor="let note of notes; let i = index" class="flex gap-2 justify-between mr-1 mb-1" data-testid="encounter-note-item">
                    <div class="flex py-1.5 w-full">
                      <p class="body-medium text-inverse-on-surface self-center break-all" data-testid="encounter-note-text">{{ note.note }}</p>
                    </div>
                    <button mat-icon-button (click)="confirmDeleteNote(i)" data-testid="encounter-delete-note-button">
                      <mat-icon class="!text-inverse-on-surface opacity-50 !text-xl">delete</mat-icon>
                    </button>
                  </div>
                </div>
                <div class="flex sticky bottom-0 gap-2 mr-1">
                  <textarea
                    #noteTextarea
                    class="w-full bg-transparent border-none outline-none text-white placeholder:text-white placeholder:opacity-50 placeholder:pl-3 text-sm font-normal leading-5 tracking-[0.25px] resize-none"
                    [(ngModel)]="newNote" 
                    placeholder="{{ 'Add context note…' | translate }}"
                    (keydown.enter)="$event.preventDefault(); addNote()"
                    (input)="autoResize(noteTextarea, contextNotesContainer)"
                    data-testid="encounter-notes-input"></textarea>
                  <button mat-icon-button (click)="addNote()" class="self-end" data-testid="encounter-send-note-button">
                    <mat-icon class="!text-inverse-on-surface opacity-50 !text-xl">send</mat-icon>
                  </button>
                </div>
              </div>
              <!-- Context accordion section -->
              <!-- <div class="bg-[rgba(255,255,255,0.16)] flex flex-col relative w-full shrink-0 context-accordion" [ngClass]="{
                'collapsed': !isContextAccordionExpanded,
                'expanded': isContextAccordionExpanded
              }"> -->
                <!-- <div class="flex flex-col items-start justify-start overflow-clip relative rounded-lg flex-1 w-full"> -->
                  <!-- <div class="flex flex-col items-start justify-start overflow-clip relative rounded-lg flex-1 w-full"> -->
                    <!-- Accordion Heading -->
                    <!-- <div class="flex w-full px-4 pt-2 pb-6 h-20 cursor-pointer hover:opacity-80"
                         (click)="toggleContextAccordion()">
                      <div class="flex gap-1 grow items-center justify-start flex-1">
                        <mat-icon class="!text-inverse-on-surface material-symbols-outlined !text-base align-middle">collapse_all</mat-icon>
                        <p class="title-medium text-inverse-on-surface">Previous context</p>
                      </div>
                    </div> -->
                    
                    <!-- Context content -->
                    <!-- <div class="flex flex-col gap-4 items-start justify-start px-4 w-[296px] accordion-content overflow-y-auto w-full" [ngClass]="{
                      'hidden': !isContextAccordionExpanded,
                      'block': isContextAccordionExpanded
                    }"> -->
                      <!-- Personal details section -->
                      <!-- <div class="flex flex-col gap-2 items-start justify-start relative shrink-0 w-full">
                        <div class="flex gap-2.5 items-center justify-start relative flex-1 w-full">
                          <div class="flex gap-4 grow items-center justify-start flex-1">
                            <div class="font-medium leading-0 relative shrink-0 text-[#004562] text-sm text-nowrap tracking-[0.1px]">
                              <p class="leading-5 whitespace-pre">Personal details</p>
                            </div>
                          </div>
                        </div>
                        <div class="font-normal leading-0 relative shrink-0 text-[#edf1f5] text-sm tracking-[0.25px] w-full">
                          <p class="leading-5 mb-0 text-sm">
                            <span class="font-bold tracking-[0.25px]">Name:</span>
                            <span> Hank Jennings</span>
                          </p>
                          <p class="leading-5 mb-0 text-sm">
                            <span class="font-bold tracking-[0.25px]">DOB:</span>
                            <span> 09/Feb/1983</span>
                          </p>
                          <p class="leading-5 mb-0 text-sm">
                            <span class="font-bold tracking-[0.25px]">Gender:</span>
                            <span> Male</span>
                          </p>
                          <p class="leading-5 mb-0 text-sm">
                            <span class="font-bold tracking-[0.25px]">Weight: </span>
                            <span>2.2829 St. (as of 08 Jan 2023)</span>
                          </p>
                          <p class="leading-5 text-sm">
                            <span class="font-bold tracking-[0.25px]">Height: </span>
                            <span>6 ft 3</span>
                          </p>
                        </div>
                      </div> -->
                      
                      <!-- Diagnosis section -->
                      <!-- <div class="flex flex-col gap-2 items-start justify-start relative shrink-0 w-full">
                        <div class="flex gap-2.5 items-center justify-start relative flex-1 w-full">
                          <div class="font-medium leading-0 relative shrink-0 text-[#004562] text-sm text-nowrap tracking-[0.1px]">
                            <p class="leading-5 whitespace-pre">Diagnosis</p>
                          </div>
                        </div>
                        <div class="font-normal leading-0 max-w-[800px] relative shrink-0 text-[#edf1f5] text-sm tracking-[0.25px] w-full">
                          <p class="font-bold leading-5 mb-0 text-sm">Currents:</p>
                          <ul class="list-disc mb-0">
                            <li class="leading-5 mb-0 text-sm">
                              <span class="font-bold tracking-[0.25px]">Depression:</span>
                              <span> Diagnosed 03 Jun 2013</span>
                            </li>
                            <li class="leading-5 text-sm">
                              <span class="font-bold tracking-[0.25px]">Underactive thyroid:</span>
                              <span> Diagnosed 11 Dec 2010</span>
                            </li>
                          </ul>
                          <p class="font-bold leading-5 mb-0 text-sm">Past:</p>
                          <ul class="list-disc">
                            <li class="leading-5 mb-0 text-sm">
                              <span class="font-bold tracking-[0.25px]">Back pain:</span>
                              <span> Diagnosed 03 Jun 2013</span>
                            </li>
                            <li class="leading-5 text-sm">
                              <span class="font-bold tracking-[0.25px]">Underactive thyroid:</span>
                              <span> Diagnosed 11 Dec 2010</span>
                            </li>
                          </ul>
                        </div>
                      </div> -->
                      
                      <!-- Procedures section -->
                      <!-- <div class="flex flex-col gap-2 items-start justify-start relative shrink-0 w-full">
                        <div class="flex gap-2.5 items-center justify-start relative flex-1 w-full">
                          <div class="font-medium leading-0 relative shrink-0 text-[#004562] text-sm text-nowrap tracking-[0.1px]">
                            <p class="leading-5 whitespace-pre">Procedures</p>
                          </div>
                        </div>
                        <div class="font-normal leading-0 max-w-[800px] relative shrink-0 text-[#edf1f5] text-sm tracking-[0.25px] w-full">
                          <p class="mb-0">
                            <span class="font-bold leading-5 text-sm tracking-[0.1px]">Blood Test:</span>
                            <span class="font-bold leading-4 text-xs tracking-[0.5px]"> </span>
                            <span class="font-normal leading-5 text-sm tracking-[0.25px]">(05 Oct 2024) Routine blood work to check for various conditions</span>
                          </p>
                          <p class="leading-5 text-sm">
                            <span class="font-bold tracking-[0.1px]">X-Ray : </span>
                            <span class="font-normal tracking-[0.25px]">(07 Oct 2024) Imaging for suspected fractures or other issues</span>
                          </p>
                        </div>
                      </div>
                    </div> -->
                  <!-- </div> -->
                <!-- </div> -->
              <!-- </div> -->
            </div>
          </div>
        </div>


      <!-- Transcript drawer -->
      <!-- <div *ngSwitchCase="'transcript'" class="h-full flex flex-col">
        <div class="px-4 h-14 flex items-center justify-between">
          <span class="title-medium text-inverse-on-surface">{{ 'Transcript / Context' | translate }}</span>
          <button class="p-2 opacity-80 hover:opacity-100" (click)="closeDrawer()">
            <span class="material-icons text-inverse-on-surface text-sm">close</span>
          </button>
        </div>
        <div class="flex-1 overflow-y-auto p-4 body-medium text-inverse-on-surface space-y-2">
          <div *ngIf="transcript.length === 0" class="text-white">{{ 'No transcript yet.' | translate }}</div>
          <div *ngFor="let item of transcript; let i = index" class="flex items-start gap-2">
            <div class="label-small text-outline-variant w-6 text-right">{{ i + 1 }}</div>
            <div class="flex-1 bg-white/8 border border-outline p-2 rounded">{{ item }}</div>
          </div>
        </div>
      </div> -->
    </ng-container>
    }
  </mat-sidenav>

  <mat-sidenav-content class="h-screen">
    <div class="flex flex-col h-full min-h-0 overflow-hidden">
    @if (networkInterruptionOccurred) {
      <app-connection-banner />
    }
    <ng-template #loading>
      <div class="flex-1 min-h-0 flex items-center justify-center" data-testid="encounter-loading-spinner">
        <mat-spinner diameter="48"></mat-spinner>
      </div>
    </ng-template>
    <div class="flex flex-1 min-h-0" *ngIf="!isInitializingRecorder; else loading">
      <div class="flex flex-col flex-1 min-w-0 min-h-0">
      <!-- Top Navigation Bar -->
      <div class="flex items-center px-4 md:px-8 pt-3 md:pt-4 h-14 flex-shrink-0">
        <!-- Logo -->
        <div class="h-6 mr-4 hidden md:block">
          <img [src]="topNavLogoSrc" alt="T-PRO" class="h-full w-auto">
        </div>
        <!-- Breadcrumbs -->
        <div class="flex items-center gap-2">
          <button (click)="onBreadcrumbClick()" data-testid="encounter-home-button"
            class="label-medium cursor-pointer px-2 py-1 rounded-md hover:bg-surface encounter-nav-text encounter-nav-link">{{ 'Home' | translate }}</button>
          <span class="material-icons material-symbols-outlined text-outline-variant text-sm">chevron_right</span>
          <div class="flex items-center gap-1 relative">
            <span class="label-medium encounter-nav-text" data-testid="encounter-patient-name">{{ dictation?.copilot?.subject_name || ('No patient' | translate)}}</span>
            <button (click)="openPatientEditor()" class="inline-flex items-center cursor-pointer rounded-md pl-1 p-0.5 encounter-nav-text" data-testid="encounter-edit-patient-button">
              <mat-icon svgIcon="edit-pencil" class="icon-size [--icon-size:16px]"></mat-icon>
            </button>
          </div>
        </div>
        <div class="flex-1"></div>
      </div>

      <!-- Middle content - grows to fill available space -->
      <div class="flex-1 flex flex-col items-center justify-center w-full min-w-0 px-4 md:w-[360px] md:px-0 mx-auto">

        <!-- Offline state layout intentionally disabled -->
        <!--
        <div class="text-center w-[311px]">
          <div class="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 bg-outline-variant">
            <mat-icon class="!text-[40px] !h-10 !w-10 !text-on-surface-variant">
              wifi_off
            </mat-icon>
          </div>
          <div>
            <h1 class="title-large mb-3 encounter-error-title">{{ 'You are offline' | translate }}</h1>
            <h2 class="body-medium encounter-error-message">
              {{ 'Internet connection lost. Recording paused.' | translate }}
            </h2>
          </div>
        </div>
        -->
        <!-- Waveform/Microphone Section -->
        <div class="flex items-center justify-center gap-2 h-15 mb-16" [ngClass]="{
            'mb-12': isBlueTheme,
          }">
          <!-- Left bracket -->
          <mat-icon svgIcon="left-bracket" class="!h-12 bracket encounter-bracket"></mat-icon>

          <!-- Microphone icon (Initial state) -->
          <div *ngIf="encounterUiState === 'initial'" class="flex justify-center items-center !h-10 !w-10">
            <mat-icon svgIcon="microphone" class="encounter-mic icon-size [--icon-size:100%] [--icon-stroke-width:1]"></mat-icon>
          </div>
          
          <!-- Audio visualizer (Recording state) -->
          <canvas #audioVisualizer [attr.width]="visualizerWidth" [attr.height]="visualizerHeight" class="mx-auto"
            *ngIf="encounterUiState === 'recording'"></canvas>

          <!-- Static waveform (Paused state) -->
          <div class="flex items-center justify-center" [style.width.px]="visualizerWidth"
            [style.gap.px]="barSpacing" *ngIf="encounterUiState === 'paused'">
            <div class="bg-on-primary/80 rounded-full" *ngFor="let _ of pausedWaveformBars"
              [style.width.px]="visualizerBarWidth" [style.height.px]="visualizerBarWidth"></div>
          </div>

          <!-- Right bracket -->
          <mat-icon svgIcon="right-bracket" class="!h-12 encounter-bracket"></mat-icon>
        </div>

        <!-- Timer and Content Section -->
        <div class="display-large encounter-timer flex items-baseline justify-center tabular-nums" data-testid="encounter-recording-timer">
          @if (recordingTimeParts.hours) {
            <span>{{ recordingTimeParts.hours }}</span>
            <span class="encounter-timer-separator" aria-hidden="true">:</span>
          }
          <span>{{ recordingTimeParts.mins }}</span>
          <span class="encounter-timer-separator" aria-hidden="true">:</span>
          <span>{{ recordingTimeParts.secs }}</span>
        </div>

        @if (isMobile) {
          <div class="w-full flex justify-center mt-4">
            <ng-container *ngTemplateOutlet="micSelector" />
          </div>
        }

        <!-- Instructions Section (Initial). Fixed height keeps the timer and actions in place. -->
        <div class="flex h-[120px] w-full flex-col overflow-hidden mt-8 md:mt-4" *ngIf="encounterUiState === 'initial'"
          [ngClass]="{'justify-center items-center' : requirePatientConsent}">
          <!-- Reminder patient consent -->
          <div *ngIf="!requirePatientConsent" class="flex flex-col w-full text-center gap-4" data-testid="encounter-before-you-begin">
            <div class="title-large text-primary-container">
              {{ 'Before you begin' | translate }}
            </div>
            <div class="body-large text-on-primary">
              {{ "Please make sure you have your patient's consent to record" | translate }}
            </div>
          </div>

          <!-- Patient consent. -->
          <div *ngIf="requirePatientConsent" class="flex w-full items-center justify-center overflow-hidden" data-testid="encounter-consent">
            <div class="flex w-fit max-w-full items-start gap-1">
              <mat-checkbox
                #consentCheckbox="matCheckbox"
                id="encounter-patient-consent"
                [(ngModel)]="patientConsentGiven"
                class="shrink-0"
                data-testid="encounter-consent-checkbox">
              </mat-checkbox>
              <label
                class="body-medium min-w-0 cursor-pointer break-words text-start normal-case text-on-primary pt-[calc((var(--mdc-checkbox-state-layer-size,40px)-20px)/2)]"
                [for]="consentCheckbox.inputId"
                data-testid="encounter-consent-message">
                {{ patientConsentMessage }}
              </label>
            </div>
          </div>
        </div>

        @if (!isMobile) {
          <div class="flex flex-col gap-8 items-center mt-8">
            <ng-container *ngTemplateOutlet="actionButtons" />
          </div>
        }

      </div>

      <!-- Bottom actions -->
      <div
        class="flex flex-col gap-3 px-4 md:flex-row md:justify-between md:items-end md:gap-0 md:px-6 md:h-[55px] md:pb-0"
        [ngClass]="isMobile && showEncounterContentPanel
          ? 'pb-[calc(var(--content-panel-collapsed-height,72px)+1.5rem+env(safe-area-inset-bottom,0px))]'
          : isMobile
            ? 'pb-[calc(5rem+env(safe-area-inset-bottom))]'
            : ''"
        [style.--content-panel-collapsed-height.px]="contentPanelCollapsedHeightPx"
        data-testid="encounter-bottom-bar">
        @if (isMobile) {
          @if (!showEncounterContentPanel && !rightDrawer?.opened) {
            <button
              type="button"
              (click)="openDrawer('context')"
              data-testid="encounter-notes-trigger"
              class="inline-flex items-center gap-1.5 body-large cursor-pointer bg-transparent border-none p-4 self-center"
              [ngClass]="isLightTheme ? 'text-on-surface-variant' : 'text-on-primary'">
              <mat-icon class="material-symbols-outlined shrink-0">article</mat-icon>
              {{ 'Notes' | translate }}
            </button>
          }
          <div class="flex flex-col gap-3 items-center w-full">
            <ng-container *ngTemplateOutlet="actionButtons" />
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="micSelector" />
          @if (!showEncounterContentPanel && !rightDrawer?.opened) {
            <button
              type="button"
              (click)="openDrawer('context')"
              data-testid="encounter-notes-trigger"
              class="flex items-center h-[55px] rounded-tr-lg rounded-tl-lg border-t border-l border-r pr-2 bg-[rgba(255,255,255,0.08)] cursor-pointer encounter-notes-trigger shrink-0"
              [ngClass]="{
                'border-linear-stroke': !isLightTheme,
                'border-neutral-70': isLightTheme,
                'text-on-surface-variant': isLightTheme,
                'text-on-primary': !isLightTheme,
              }">
              <span class="w-[172px] h-full body-large inline-flex items-center justify-center">
                {{ 'Notes' | translate }}
              </span>
              <mat-icon class="material-symbols-outlined !text-lg !h-7 opacity-60">open_in_new</mat-icon>
            </button>
          }
        }
      </div>
      </div>

      @if (showEncounterContentPanel && !isMobile) {
        <div class="flex shrink-0 h-full w-full max-w-[398px] mr-8">
          <ng-container *ngTemplateOutlet="encounterContentPanel" />
        </div>
      }
    </div>
    </div>
    @if (showEncounterContentPanel && isMobile) {
      <ng-container *ngTemplateOutlet="encounterContentPanel" />
    }
  </mat-sidenav-content>

  <ng-template #micSelector>
    <div
      class="relative shrink-0"
      [ngClass]="!isMobile ? 'w-[275px] h-[55px] encounter-mic-selector-anchor--docked' : 'w-full'">
      <div
        class="encounter-mic-selector flex flex-col w-full z-10"
        [attr.data-testid]="micAccessBlocked ? 'mic-permission-alert' : 'encounter-mic-selector-container'"
        [ngClass]="{
          'absolute bottom-0 left-0 border border-b-0 rounded-t-lg bg-white/8 overflow-hidden': !isMobile,
          'encounter-mic-selector--expanded': isMicSelectorExpanded && !micAccessBlocked,
          'border-on-primary': !isMobile && !micHasError && !isLightTheme,
          'border-neutral-70': !isMobile && !micHasError && isLightTheme,
          'border-[3px] border-error': !isMobile && micHasError,
        }">
        @if (micAccessBlocked) {
          <button
            type="button"
            class="encounter-mic-selector-trigger flex items-center w-full border-0 bg-transparent cursor-pointer shrink-0"
            [ngClass]="{
              'justify-center px-4 py-3 min-h-12': isMobile,
              'justify-between h-[55px] min-h-[55px] px-4': !isMobile,
              'text-on-surface-variant': isLightTheme,
              'text-on-primary': !isLightTheme,
            }"
            (click)="retryMicrophoneAccess()"
            data-testid="mic-allow-access-button">
            <div class="inline-flex items-center gap-[7px] min-w-0 max-w-full">
              <mat-icon svgIcon="microphone-mute" class="icon-size [--icon-size:20px] shrink-0"></mat-icon>
              <span class="title-medium truncate min-w-0" data-testid="encounter-mic-selector-error-label">
                {{ micSelectorLabel | translate }}
              </span>
            </div>
          </button>
        } @else {
          <button
            type="button"
            class="encounter-mic-selector-trigger flex items-center w-full border-0 bg-transparent cursor-pointer shrink-0"
            [ngClass]="{
              'justify-center px-4 py-3 min-h-12': isMobile,
              'justify-between h-[55px] min-h-[55px] px-4': !isMobile,
              'bg-white/8': isMicSelectorExpanded && !micAccessBlocked,
              'text-on-surface-variant': isLightTheme,
              'text-on-primary': !isLightTheme,
            }"
            (click)="toggleMicSelector()"
            data-testid="encounter-mic-selector"
            [attr.aria-expanded]="isMicSelectorExpanded">
            <div class="inline-flex items-center gap-[7px] min-w-0 max-w-full">
              <mat-icon svgIcon="microphone" class="icon-size [--icon-size:20px] shrink-0"></mat-icon>
              <span class="title-medium truncate min-w-0">
                {{ selectedMicrophoneLabel }}
              </span>
            </div>
            @if (!isMobile) {
              <mat-icon class="!text-base shrink-0 opacity-80">
                {{ isMicSelectorExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
              </mat-icon>
            }
          </button>

          @if (isMicSelectorExpanded) {
            <div class="flex flex-col gap-2 p-4" data-testid="encounter-mic-selector-options">
              @for (mic of orderedMicrophones; track mic.deviceId) {
                <button
                  type="button"
                  class="encounter-mic-selector-option flex items-center gap-5 w-full min-h-5 p-0 border-0 bg-transparent cursor-pointer text-left text-white/70"
                  [class.encounter-mic-selector-option--selected]="mic.deviceId === selectedMicrophone"
                  (click)="selectMicrophoneFromList(mic.deviceId)"
                  [attr.data-testid]="'encounter-mic-option-' + mic.deviceId">
                  <span class="truncate flex-1 min-w-0">{{ mic.label }}</span>
                  @if (mic.deviceId === selectedMicrophone) {
                    <mat-icon class="encounter-mic-selector-check !text-xl !w-5 !h-7 text-on-primary shrink-0">check</mat-icon>
                  }
                </button>
              }
            </div>
          }
        }
      </div>
    </div>
  </ng-template>

  <ng-template #actionButtons>
    <!-- Initial state buttons -->
    <ng-container *ngIf="encounterUiState === 'initial'">
      <div class="flex gap-4 md:gap-2 w-full md:w-[360px]">
        <button mat-stroked-button (click)="goBack()" class="flex-1" data-testid="encounter-go-back-button">
          {{ 'Go back' | translate }}
        </button>
        <button mat-flat-button color="primary" (click)="startRecording()" [ngClass]="{'opacity-[0.32]': !canBeginConsult}"
          [disabled]="!canBeginConsult" class="flex-1" data-testid="encounter-begin-consult-button">
          {{ (startingEncounter ? 'Starting ...' : 'Begin consult') | translate }}
        </button>
      </div>
    </ng-container>

    <!-- Recording state buttons -->
    <div class="flex gap-2 w-full md:w-[361px]" *ngIf="encounterUiState === 'recording'">
      <button mat-stroked-button (click)="pauseRecording()"
        class="flex-1 text-on-primary border-outline-variant" data-testid="encounter-pause-button">
        <mat-icon>pause</mat-icon>
        {{ (stoppingEncounter ? 'Pausing ...' : 'Pause') | translate }}
      </button>
      <button mat-flat-button (click)="finishEncounter('recording')" class="flex-1"
        [disabled]="finishingEncounter" data-testid="encounter-finish-button">
        <mat-icon>check</mat-icon>
        {{ (finishingEncounter ? 'Finishing ...' : 'Finish') | translate }}
      </button>
    </div>

    <!-- Paused state buttons -->
    <div class="flex gap-2 w-full md:w-[361px]" *ngIf="encounterUiState === 'paused'">
      @if (stoppingEncounter) {
        <button mat-stroked-button disabled
        class="flex-1 text-on-primary border-outline-variant">
        <mat-icon>pause</mat-icon>
        {{ 'Pausing ...' | translate }}
      </button>
      } @else {
        <button mat-stroked-button (click)="resumeRecording()" class="flex-1" [disabled]="resumingEncounter || recorderLoading || finishingEncounter || durationLimitReached || micAccessBlocked" data-testid="encounter-resume-button">
          <mat-icon class="material-symbols-outlined !text-3xl !w-6 !h-9 shrink-0">play_arrow</mat-icon>
          {{ ((resumingEncounter || recorderLoading) ? 'Resuming ...' : 'Resume') | translate }}
        </button>
      }
      <button mat-stroked-button (click)="finishEncounter('paused')" class="flex-1"
        [disabled]="resumingEncounter || startingEncounter || finishingEncounter || recorderLoading" data-testid="encounter-finish-paused-button">
        <mat-icon>check</mat-icon>
        {{ (finishingEncounter ? 'Finishing ...' : 'Finish') | translate }}
      </button>
    </div>
  </ng-template>

</mat-sidenav-container>